import React from 'react'
import { styled } from '@mui/material'

type Props = {
  numerator: React.ReactNode
  denominator: React.ReactNode
}

const Fraction: React.FC<Props> = ({ numerator, denominator }) => (
  <StyledFraction>
    <Numerator>{numerator}</Numerator>
    <span>{denominator}</span>
  </StyledFraction>
)

const StyledFraction = styled('span')(() => ({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  verticalAlign: 'middle',
  fontSize: '0.85em',
  lineHeight: 1.1,
  margin: '0 2px',
}))

const Numerator = styled('span')(() => ({
  borderBottom: '1px solid currentColor',
  padding: '0 2px',
}))

export default Fraction
